<template>
  <div class="box" :style="{width: width,minWidth:'120px',backgroundColor:this.localValue?checkedColor:'#fff'}">
    <a-row type="flex">
      <a-col flex="auto">{{label}}</a-col>
      <a-col flex="30px">
        <a-checkbox :checked="localValue">
        </a-checkbox>
      </a-col>
    </a-row>
    <div style="position: absolute;width: 100%;height:40px;cursor: pointer;top: 0;left: 0;z-index: 1" @click.prevent="onChange(e)"></div>
  </div>
</template>

<script>
import mixin from '../mixin/AExtBooleanMixin'
export default {
    name: "index",
    mixins:[mixin],
    props:{
      label:{
          type:String,
          default:''
      },
      width:{
        type:String,
        default: '50px'
      },
        checkedColor:{
          type:String,
            default:'#E5EDF7'
        }
    },
    data(){
      return {
          localValue: false
      }
    },
    created(){
      this.init()
    },
    methods:{
        init(){
            if(!this.localValue)
            {
                this.localValue=false;
            }
        },
        onChange(e)
        {
            this.localValue=!this.localValue;
            this.$emit("change",'')
        }
    }
}
</script>

<style scoped>
  .box{
    position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
  }
</style>